<template>
  <div ref="grtcVideo" :userId="props.userId" class="grtc-video"></div>
</template>

<script setup>
  import { nextTick, ref, watch, onMounted } from 'vue';


  const props = defineProps({
    userId: {
      type: String,
      default: "",
      required: true
    }
  });

  const grtcVideo = ref(null);
  async function play(userId) {
    if (!userId) return;
    const el = grtcVideo.value;
    if (!el) return;
    // 先把 userId 写到容器上，再让 SDK 绑定渲染（避免找不到容器导致黑屏）
    el.setAttribute("userId", userId);
    // 不同版本 SDK 可能读取小写属性名
    el.setAttribute("userid", userId);
    await nextTick();
    try {
      const maybePromise = window.GRTC?.play?.(userId);
      maybePromise?.catch?.(() => {});
    } catch (_) {}
  }

  onMounted(() => {
    play(props.userId);
  });

  watch(() => props.userId, (newVal) => {
    play(newVal);
  });
</script>

<style>
  /* 添加样式 */
  .grtc-video {
    width: 100%;
    height: 100%;
    background-color: #000;
  }
</style>
